import { useEffect, useState } from "react";
import { API } from "../api";

// Calls onOutside when a mousedown lands outside the element behind ref.
export function useClickOutside(ref, onOutside) {
  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) onOutside();
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref]);
}

// NEED category labels from the catalog, de-duplicated; error is set when they could not be loaded.
export function useNeedCategories() {
  const [categories, setCategories] = useState([]);
  const [error, setError] = useState(null);
  useEffect(() => {
    let cancelled = false;
    API.get("/api/metadata/categories")
      .then((res) => { if (!cancelled) setCategories([...new Set(res.data?.categories || [])]); })
      .catch(() => { if (!cancelled) setError("Could not load NEED categories"); });
    return () => { cancelled = true; };
  }, []);
  return { categories, error };
}

// The German states from the location store, tagged as state-level picks.
export async function fetchStates() {
  try {
    const { data } = await API.get("/locations/states/DEU");
    return (data || []).map((s) => ({ ...s, type: "state" }));
  } catch (err) {
    console.error("Failed to load states:", err);
    return [];
  }
}
